/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import {useQuery, useMutation} from "@apollo/client";
import Registration from './registration';
import {SUBMIT_CODE} from '../../queries/mutations';
import {CREATE_USER} from '../../queries/mutations';
import {GET_PROFESSIONS_QUERY} from '../../queries/queries';
import Loading from '../loading';
import Error from '../error';


const RegistrationContainer = ({match}) => {
  let history = useHistory();
  const givenCode = match.params.code;
  const [registrationCode, setRegistrationCode] = useState(givenCode);
  const [errorMessage, setErrorMessage] = useState();
  const [pharmacy, setPharmacy] = useState();
  const [gender, setGender] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [legalChecked, setLegalChecked] = useState(false);
  const [professionId, setProfessionId] = useState('');

  const [createUser] = useMutation(CREATE_USER, {
    onCompleted(data) {
      setErrorMessage(null);
      history.push(`/welcome/${pharmacy.name}`);
    },
    onError: data => {
      setErrorMessage(data.graphQLErrors[0].message);
    },
  });

  const [submitCode] = useMutation(SUBMIT_CODE, {
    onCompleted: data => {
      setErrorMessage(null);
      setPharmacy(data.submitRegistrationCode.pharmacy);
    },
    onError: data => {
      setErrorMessage('Code nicht korrekt');
    },
  });

  const {loading, error, data} = useQuery(GET_PROFESSIONS_QUERY);

  const handleRegistrationCodeChange = e => {
    setRegistrationCode(e.target.value);
  };

  const handleFirstNameChange = e => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = e => {
    setLastName(e.target.value);
  };

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };

  const handleProfessionChange = e => {
    setProfessionId(e.target.value);
  };

  const handlePasswordChange = e => {
    setPasswordMatch(e.target.value === passwordConfirmation);
    setPassword(e.target.value);
  };

  const handlePasswordConfirmationChange = e => {
    setPasswordMatch(e.target.value === password);
    setPasswordConfirmation(e.target.value);
  };

  const handleRegistrationCodeSubmit = () => {
    history.push(`/registration/${registrationCode}`);
  };

  const checkCode = () => {
    submitCode({
      variables: {registrationCode: registrationCode},
    });
  };

  const handleRegistrationSubmit = () => {
    if(!passwordMatch) {
      setErrorMessage('Passwörter stimmen nicht überein');
      return 
    }
    
    createUser({
      variables: {
        gender,
        firstName,
        lastName,
        email,
        password,
        professionId: professionId,
        pharmacyId: pharmacy.id,
      },
    });
  };

  const handleGenderChange = e => {
    setGender(e.target.value);
  };

  const toggleLegalChecked = e => {
   setLegalChecked(!legalChecked)
  }

  useEffect(() => {
    if (givenCode) {
      checkCode();
    }
  },[givenCode]);

  if (loading) return <Loading />;
  if (error) return <Error />;

  return (
    <Registration
      handleRegistrationCodeChange={handleRegistrationCodeChange}
      handleFirstNameChange={handleFirstNameChange}
      handleLastNameChange={handleLastNameChange}
      handleEmailChange={handleEmailChange}
      handlePasswordChange={handlePasswordChange}
      handlePasswordConfirmationChange={handlePasswordConfirmationChange}
      handleRegistrationCodeSubmit={handleRegistrationCodeSubmit}
      handleRegistrationSubmit={handleRegistrationSubmit}
      handleProfessionChange={handleProfessionChange}
      legalChecked={legalChecked}
      toggleLegalChecked={toggleLegalChecked}
      pharmacy={pharmacy}
      errorMessage={errorMessage}
      passwordMatch={passwordMatch}
      handleGenderChange={handleGenderChange}
      gender={gender}
      professions={data.professions}
      professionId={professionId}
      setErrorMessage={setErrorMessage}
      passwordConfirmation={passwordConfirmation}
    />
  );
};

export default RegistrationContainer;
